import { z } from "zod";

import {
  ColorIconSchema,
  DetailsPopupInfoSchema,
  WorkTimeList,
} from "@shared/content-types/schemas/common.schema";
import { DynamicZoneSchema } from "@shared/content-types/schemas/dynamicZone.schema";
import { ArrayOfMediaSchema } from "@shared/content-types/schemas/media.schema";
import { TitleWithIconSchema } from "@shared/content-types/schemas/pageHero.schema";
import { MetaSchema } from "@shared/content-types/schemas/pagination.schema";
import { SeoSchema } from "@shared/content-types/schemas/seo.schema";

export const AccommodationsPageSchema = z.object({
  id: z.number().int().positive(),
  documentId: z.string().min(1),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  publishedAt: z.string().datetime(),
  pageIcon: ColorIconSchema,
  titleWithIcon: TitleWithIconSchema,
});

export const AccommodationsTypeSchema = z.object({
  id: z.number().int().positive(),
  documentId: z.string().min(1),
  type: z.string().min(1),
  uid: z.string().min(1),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  publishedAt: z.string().datetime(),
  accommodations_points: z.array(z.any()),
});

export const AccommodationsBadgeTypeSchema = z.object({
  id: z.number().int().positive(),
  documentId: z.string().min(1),
  type: z.string().min(1),
  uid: z.string().min(1),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  publishedAt: z.string().datetime(),
  accommodations_points: z.array(z.any()),
});

export const AccommodationsPointBaseSchema = z.object({
  id: z.number().int().positive(),
  documentId: z.string().min(1),
  title: z.string().min(1),
  uid: z.string().min(1),
  description: z.string().min(1),
  phone: z
    .string()
    .regex(/^\d \(\d{3}\) \d{3} \d{2} \d{2}$/, "Invalid phone format")
    .optional(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  publishedAt: z.string().datetime(),
  email: z.string().email().optional(),
  location: z.string(),
  siteLink: z.string().optional(),
  workTimeList: z.array(WorkTimeList.dynamic).optional(),
  photos: ArrayOfMediaSchema,
  accommodations_type: AccommodationsTypeSchema.optional().nullable(),
  accommodations_badge_types: z.array(AccommodationsBadgeTypeSchema).min(0),
  coordinates: z.string(),
  detailInfo: z.array(DetailsPopupInfoSchema),
  content: DynamicZoneSchema.optional().nullable(),
  seo: SeoSchema.optional().nullable(),
});

export const AccommodationsPointSchema = AccommodationsPointBaseSchema.extend({
  other_accommodations: z.array(AccommodationsPointBaseSchema).optional(),
});

export const AccommodationsPageDtoSchema = z.object({
  data: AccommodationsPageSchema,
});

export const AccommodationsPointDtoSchema = z.object({
  data: z.array(AccommodationsPointSchema).min(0),
  meta: MetaSchema,
});

export const AccommodationsTypesDtoSchema = z.object({
  data: z.array(AccommodationsTypeSchema).min(0),
  meta: MetaSchema,
});

export const AccommodationsBadgeTypesDtoSchema = z.object({
  data: z.array(AccommodationsBadgeTypeSchema).min(0),
  meta: MetaSchema,
});
